import { Space, Button, Input, InputRef } from 'antd';
import React, { useCallback, useEffect, useMemo } from 'react';
import { useDataSheetPager } from './context';
import { Messages } from '../../constant/messages';

type Props = {
  isDurty: boolean;
};

export const DataSheetPager: React.FC<Props> = ({ isDurty }) => {
  const pager = useDataSheetPager();
  const total = useMemo(() => Math.ceil(pager.total / pager.parPage), [pager]);
  const ref = React.useRef<InputRef>(null);

  const handleChange = useCallback((page: number) => {
    if (isDurty) {
      window.alert(Messages.ERR_DIRTY);
      return;
    }
    pager.onChange(page);
  }, [pager, isDurty]);

  const move = useCallback((offset: number) => {
    if (pager.page + offset < 1 || pager.page + offset > total) {
      return;
    }
    handleChange(pager.page + offset);
  }, [pager, total, handleChange]);

  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    e.preventDefault();
    const value = parseInt(e.target.value, 10);
    if (Number.isNaN(value)) {
      return;
    }
    if (value < 1 || value > total) {
      return;
    }
    handleChange(value);
  }, [total, handleChange]);

  return (
        <div>
            <Space>
                <Button type={'text'} onClick={() => move(-1)} disabled={pager.page <= 1}>&lt;</Button>
                <Input ref={ref} type={'text'} onChange={onChange} style={{ width: 50, textAlign: 'center' }} value={'' + pager.page}/>
                &nbsp; / &nbsp;
                <span style={{ fontSize: '0.9em' }}>{total}</span>
                <Button type={'text'} onClick={() => move(1)} disabled={pager.page >= total}>&gt;</Button>
            </Space>
        </div>
  );
};
